import { render, staticRenderFns } from "./FoodcourtLevelsList.vue?vue&type=template&id=47efc6ea&scoped=true"
import script from "./FoodcourtLevelsList.vue?vue&type=script&lang=js"
export * from "./FoodcourtLevelsList.vue?vue&type=script&lang=js"
import style0 from "./FoodcourtLevelsList.vue?vue&type=style&index=0&id=47efc6ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47efc6ea",
  null
  
)

export default component.exports